$('[data-element="influencer-diff"]').submit(event => {
  var inputs = $(event.currentTarget).find('input');
  for (var i = 0; i < inputs.length; i++) {
    if (inputs[i].value == '') {
      alert('Please merge all the fields');
      return false;
    }
  }
  return true;
});

$('[data-element="influencer-diff"]').find('[data-action="pick-a"]').click(event => {
  var key = event.currentTarget.dataset.key;
  $('[data-picked][data-key="' + key + '"]').val('a');
  $('[data-picked-html][data-key="' + key + '"]').html(
    $('[data-element="influencer-diff"]').
      find('[data-value-a="' + key + '"]').
      html()
  );
  $('[data-element="influencer-diff"]').
    find('[data-row="' + key + '"]').
    removeClass('table-danger').
    addClass('table-success');
});

$('[data-element="influencer-diff"]').find('[data-action="pick-b"]').click(event => {
  var key = event.currentTarget.dataset.key;
  $('[data-picked][data-key="' + key + '"]').val('b');
  $('[data-picked-html][data-key="' + key + '"]').html(
    $('[data-element="influencer-diff"]').
      find('[data-value-b="' + key + '"]').
      html()
  );
  $('[data-element="influencer-diff"]').
    find('[data-row="' + key + '"]').
    removeClass('table-danger').
    addClass('table-success');
});
